import { z } from "zod";
import { AuthProvider } from "./enums/auth-provider";
import { Chain } from "./enums/chain";
import { UserTier } from "./enums/user-tier";
import { PresetSchema } from "./preset";

export const UserInfoSchema = z.object({
  name: z.string().nullish(),
  handle: z.string().nullish(),
  photo: z.string().nullish(),
});

export const UserLevelSchema = z.object({
  level: z.coerce.number(),
  title: z.string(),
  xp: z.coerce.number(),
  cashback: z.coerce.number(),
});

export const UserProfileSchema = z.object({
  name: z.string().nullish(),
  handle: z.string().nullish(),
  photo: z.string().nullish(),
});

export const TierConfigSchema = z.object({
  tier: z.enum(UserTier),
  referralPercentage: z.record(z.string(), z.coerce.number()),
  autoApproveReferrals: z.boolean(),
  cashback: z.coerce.number().optional(),
});

export const UserSchema = z.object({
  id: z.uuid(),
  username: z.string(),
  organisation_id: z.uuid(),
  provider: z.enum(AuthProvider).optional(),
  presets: z.partialRecord(z.enum(Chain), z.array(PresetSchema)),
  created_at: z.string().transform((date) => new Date(date)),
  selected_preset: z.number(),
  has_access: z.boolean(),
  xp: z.coerce.number(),
  total_volume: z.coerce.number().nullish().default(0),
  points: z.coerce.number(),
  level: UserLevelSchema,
  profile: UserProfileSchema,
  settings: z.record(z.string(), z.unknown()).nullish(),
  tier: TierConfigSchema.nullish(),
});

export type User = z.infer<typeof UserSchema>;

export type UserLevel = z.infer<typeof UserLevelSchema>;

export type UserProfile = z.infer<typeof UserProfileSchema>;

export type UserInfo = z.infer<typeof UserInfoSchema>;

export type TierConfig = z.infer<typeof TierConfigSchema>;
